import labels from '../../../../contexts/CruiseSearchContext/labels.json';

export const PROMO_CODE_ID = 'promo-code';

export const TEST_DATA = {
  data: {
    campaignId: '62833c4e7f42ab00120a8b02',
    id: '629f097b7f42ab00120a8b2e',
    code: 'air-16-05-2022',
    couponCode: 'AIR',
    title: 'Kevin TO Test1 - USA English Title',
    startDate: '2022-05-16T15:30:00.000Z',
    endDate: '2023-01-31T19:00:00.000Z',
    description: 'Kevin TO Test1 - USA English Description',
    termsAndConditions: {
      link: '/terms-and-conditions/promotions/air-16-05-2022',
      experienceFragment:
        '/content/experience-fragments/promotions/2022/january/january_monthly/terms_and_conditions/es/usa-usd.html',
    },
  },
  labels,
};

export const PROMO_APPLIED = 'promoApplied';
export const PROMO_EXPIRES = 'promoExpires';
export const PROMO_SOLDOUT = 'promoSoldOut';
export const PROMO_CASINO = 'promoCasino';
export const PROMO_ERROR = 'promoError';

export const PROMOTION_STATUS_ACTIVE = 'active';
export const PROMOTION_STATUS_EXPIRED = 'expired';
export const PROMOTION_STATUS_UPCOMING = 'upcoming';
